import * as Sentry from '@sentry/react';
import { getCurrentUser } from 'aws-amplify/auth';
import { getKeystore } from 'store/keystore/thunks';
import { handleGoogleUserClasses } from 'store/googleClassRoom/thunks';
import { handleSyncSchoologyClasses } from 'store/schoology/thunks';
import { handeleCanvasUserClasses } from 'store/canvas/thunks';
import { handleCleverUserClasses } from 'store/clever/thunks';
import { handleUserClassesSync } from 'store/classlink/thunks';

const syncClasses = async (userInfo) => {
    try {
        if (userInfo && userInfo.id) {
            if (userInfo.googleId) {
                await handleGoogleUserClasses(userInfo.googleId)
            }
            else if (userInfo.schoologyid) {
                await handleSyncSchoologyClasses(userInfo.schoologyid)
            }
            else if (userInfo.canvas_id && userInfo.canvas_auth_id) {
                await handeleCanvasUserClasses(null, userInfo.canvas_id, userInfo.canvas_auth_id)
            } else if (userInfo.cleverId) {
                await handleCleverUserClasses(userInfo.cleverId)
            } else if (userInfo.classlinkid && userInfo.classlinkTenantId) {
                await handleUserClassesSync(userInfo.classlinkid, userInfo.classlinkTenantId)
            }
        }
    } catch (error) {
        Sentry.captureException(`598-login Error in syncClasses: ${error}`);
    }
}

export const handleOnceLogin = async ({ 
    key, 
    setIsAutoLogin, 
    setError, 
    loginWithSchoology,
    dispatch
}) => {
    setIsAutoLogin(true)
    try {
        if (!key) {
            setError('Invalid login token. Please try login again!')
            return
        }

        const keyinfo = await getKeystore(key)
        
        if (!keyinfo || !keyinfo.success) {
            setError('Token is expired or invalid. Please try login again!')
            return
        }

        if (!keyinfo.data || typeof keyinfo.data !== 'object') {
            setError('Invalid token data. Please try login again!')
            return
        }

        const { token, active } = keyinfo.data

        if (active === false) {
            setError('Your account is now inactive.', "Please, contact our customer support for answers.")
            return
        }

        const existingUser = await getCurrentUser().catch(() => null);
        if (existingUser?.username && keyinfo.data?.username) {
            setIsAutoLogin(false);
            sessionStorage.setItem('username', keyinfo.data.username);
            await loginWithSchoology(keyinfo.data);
            return;
        }

        if (!token || !dispatch) {
            setError('Invalid login token. Please try login again!')
            return
        }

        const { handleLoginWithToken } = await import('store/auth/thunks');
        const result = await dispatch(handleLoginWithToken(token));
        if (!result || !result.isSignedIn) {
            setError('Authentication failed. Please try login again!');
            setIsAutoLogin(false);
            return;
        }

        try {
            await syncClasses(keyinfo.data)
        } catch (syncError) {
            Sentry.captureException(`Class sync error in handleOnceLogin: ${syncError}`)
        }

        try {
            await loginWithSchoology(keyinfo.data)
        } catch (schoologyError) {
            Sentry.captureException(`Schoology login error in handleOnceLogin: ${schoologyError}`)
        }

    } catch (error) {
        Sentry.captureException(`599 Error in handleOnceLogin: ${error}`);
        setError('Token is expired or invalid. Please try login again!')
    } finally {
        setIsAutoLogin(false)
    }
}
